import React, { useState } from 'react';

import testIds from '@smart-tv/e2e/shared/variables';

import Typography from '@smart-tv/components/typography';

import useInterval from '@smart-tv/hooks/use-interval';

import formatDate from '@smart-tv/utils/date/format-date';

import styles from './clock.module.scss';
import clsx from 'clsx';

const DEFAULT_UPDATE_INTERVAL = 1000;

export interface Props {
  updateInterval?: number;
  className?: string;
}

export const Clock = (props: Props) => {
  const { updateInterval = DEFAULT_UPDATE_INTERVAL, className, ...rest } = props;

  const [time, setTime] = useState(formatDate(new Date(), 'hh:mm'));

  useInterval(() => setTime(formatDate(new Date(), 'hh:mm')), updateInterval);

  return (
    <Typography
      className={clsx(styles['clock'], className)}
      variant="h4"
      {...rest}
      data-testid={testIds.general.clock}
    >
      {time}
    </Typography>
  );
};

export default React.memo(Clock);
